import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _isFunction from "lodash/isFunction";

/**
 * print.ts - 单据页面元素get/set方法
 * @Author: 徐昭 <zhao.xu@hand-china.com>
 * @Date: 2020/4/13 19:22
 * @LastEditTime: 2020/4/13 19:22
 * @Copyright: Copyright (c) 2020, Hand
 */
import { mapCustomize } from "hzero-front/lib/utils/customize";
export function loadPageElementAsync(_x, _x2, _x3) {
  return _loadPageElementAsync.apply(this, arguments);
}

function _loadPageElementAsync() {
  _loadPageElementAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(module, elementCode, scope) {
    var element;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!mapCustomize.has({
              module: module,
              feature: 'pageElement',
              key: "".concat(scope, "-").concat(elementCode)
            })) {
              _context.next = 4;
              break;
            }

            element = mapCustomize.get({
              module: module,
              feature: 'pageElement',
              key: "".concat(scope, "-").concat(elementCode)
            });

            if (!_isFunction(element && element.component)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", element.component());

          case 4:
            return _context.abrupt("return", null);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadPageElementAsync.apply(this, arguments);
}

export function setPageElement(module, elementCode, element, scope) {
  mapCustomize.set({
    module: module,
    feature: 'pageElement',
    key: "".concat(scope, "-").concat(elementCode),
    data: {
      component: element
    }
  });
}
/**
 * 费用报销单页面元素-配置
 * @param elementCode 页面元素代码
 * @param element 页面对象
 */

export function setReportPageElement(elementCode, element) {
  setPageElement('hfins-ec-front-exp', elementCode, element, 'report');
}
/**
 * 费用申请单页面元素-配置
 * @param elementCode 页面元素代码
 * @param element 页面对象
 */

export function setRequisitionPageElement(elementCode, element) {
  setPageElement('hfins-ec-front-exp', elementCode, element, 'requisition');
}
/**
 * 应付发票页面元素配置
 * @param elementCode
 * @param element
 */

export function setAcpInovicePageElement(elementCode, element) {
  setPageElement('hfins-ec-front-acp', elementCode, element, 'acpInvoice');
}
/**
 * 总账报账单页面元素配置
 * @param elementCode
 * @param element
 */

export function setGlJournalPageElement(elementCode, element) {
  setPageElement('hfins-ec-front-gl', elementCode, element, 'glJournal');
}
/**
 * 应付发票页面元素配置
 * @param elementCode
 * @param element
 */

export function setReceiptAcpInvoicePageElement(elementCode, element) {
  setPageElement('hfins-ec-front-receipt', elementCode, element, 'acpInvoice');
}